import { getDocumentPageUrl, getPinterestAssetUrl } from './url-helpers';
import { openPopup } from './utils';
export function sharePublicationOnPinterest(config, publication, pageNumber) {
    shareLinkOnPinterest({
        title: publication.title,
        description: publication.description,
        url: getDocumentPageUrl({
            mainHost: config.hosts.main,
            documentName: publication.name,
            username: publication.username,
            pageNumber,
        }),
        imageUrl: getPinterestAssetUrl({
            multimediaHost: config.hosts.multimedia,
            username: publication.username,
            documentName: publication.name,
            pageNumber,
        }),
    });
}
export function shareLinkOnPinterest(link) {
    const description = link.title && link.description && link.title !== link.description
        ? `${link.title}\n\n${link.description}`
        : link.title;
    const params = {
        description,
        url: link.url,
        media: link.imageUrl,
    };
    openPopup({
        url: 'https://www.pinterest.com/pin/create/button',
        params,
    });
}
//# sourceMappingURL=pinterest.js.map